// extracted by mini-css-extract-plugin
export default {"buttonBackToHome":"ButtonBackToHome_buttonBackToHome__Q7nVd"};